/* eslint-disable jira/filename-case */
export const DEFAULT_PREFETCH_MAX_AGE: number = 10 * 1000;
